/**
 * A small status label.
 *
 * The text carries the meaning and the colour only reinforces it. A badge that
 * says "active" in green and "suspended" in red is legible to someone who
 * cannot distinguish the two; a pair of coloured dots is not.
 */

import type { ReactNode } from "react";

import "./data.css";

export type BadgeTone = "neutral" | "success" | "warning" | "danger" | "info";

export function Badge({ tone = "neutral", children }: { tone?: BadgeTone; children: ReactNode }) {
  return (
    <span className="hardauto-badge" data-tone={tone}>
      {children}
    </span>
  );
}
